import { type ComponentProps, useRef } from 'react';

import { Transition, TransitionGroup } from 'react-transition-group';

import { Box } from '@change-corgi/design-system/layout';

import type { ShareFeedItem as ShareFeedItemType } from 'src/app/pages/psf/share/pageContext';

import { ITEM_MIN_HEIGHT, ShareFeedItem } from './components/ShareFeedItem';
import { useShareFeed } from './hooks/useShareFeed';

type Props = {
	items: readonly ShareFeedItemType[];
	animationStartSize: number;
};

export function ShareFeed({ items, animationStartSize, ...rest }: Props & ComponentProps<typeof Box>) {
	const { data } = useShareFeed(items, animationStartSize);
	const nodeRef = useRef<HTMLDivElement>(null);

	return (
		<Box sx={{ position: 'relative', height: '100%', overflow: 'hidden' }} {...rest}>
			<Box sx={{ position: 'absolute', height: '100%', width: '100%' }}>
				<TransitionGroup component="ul">
					{data.items.map((item) => (
						<Transition key={item.id} nodeRef={nodeRef} timeout={data.animateSpeed}>
							{(state) => (
								<ShareFeedItem
									item={item}
									as="li"
									p={16}
									sx={{
										transition: `margin-top ${data.animateSpeed}ms ease-in-out`,
										mt:
											state === 'entering'
												? -1 * (nodeRef.current ? nodeRef.current.clientHeight : ITEM_MIN_HEIGHT)
												: 0,
										visibility: state === 'entered' ? 'visible' : 'hidden',
									}}
								/>
							)}
						</Transition>
					))}
				</TransitionGroup>
			</Box>
			<Box
				sx={{
					position: 'absolute',
					bottom: 0,
					left: 0,
					width: '100%',
					height: 60,
					background: 'linear-gradient(rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255) 100%)',
				}}
			></Box>
		</Box>
	);
}
